
























import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component({
  name: 'resetPasswordRequest',
})
export default class ResetPasswordRequest extends Vue {
  // Locals
  email: string = '';
  valid: boolean = false;
  errors: string[] = [];
  loading: boolean = false;
  failed: boolean = false;

  handleRequest(): void {
    var self = this;

    if (this.email) {
      this.loading = true;
      this.$store
        .dispatch('auth/resetPasswordRequest', {
          email: this.email,
        })
        .then((response: IApi<string>) => {
          self.loading = false;
          self.$router.push({
            name: 'pleaseConfirmEmail',
            params: {
              userId: self.email,
            },
          });
        })
        .catch((error: any) => {
          self.failed = true;
          self.loading = false;
        });
    }
  }
}
